// src/hooks/useLang.js
// Usage:
//   const { t, lang, setLang, isAr } = useLang();
//   <p>{t('home.hero1')}</p>
//   <p className={isAr ? 'rtl-text' : ''}>{t('nav.requests')}</p>

import { useTranslation } from 'react-i18next';

export function useLang() {
  const { t, i18n } = useTranslation();

  function setLang(lang) {
    i18n.changeLanguage(lang);
    localStorage.setItem('transportily_lang', lang);
    // Apply RTL text direction on body for Arabic
    document.documentElement.setAttribute('data-lang', lang);
  }

  return {
    t,
    lang: i18n.language,
    setLang,
    isAr: i18n.language === 'ar',
    isDe: i18n.language === 'de',
  };
}